import * as type from "../types";

const initialState = {
  selectedCar: null,
  cars: [],
  trackAll: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case type.SET_SELECTED_CAR:
      return {
        ...state,
        selectedCar: action.value,
        trackAll: action.value ? false : true,
      };
    case type.SET_MAP_CARS: {
      return {
        ...state,
        cars: action.value,
      };
    }
    case type.CLEAR_ALL_SELECTED:
      return {
        ...state,
        selectedCar: null,
      };
    case type.TRACK_ALL_CARS:
      return {
        ...state,
        selectedCar: null,
        trackAll: true,
      };
    default:
      return state;
  }
}
